import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down-right"} maskId="square-filled-radius-0-stroke-1-IconArrowDownRight"><path fillRule="evenodd" clipRule="evenodd" d="M6.25015 4.83582L17.0002 15.5858V8.00003H19.0002V19H8.00015V17H15.5859L4.83594 6.25003L6.25015 4.83582Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDownRight;
